import React, { useEffect, useState } from "react";
import { GANGSTA_HEAD } from "src/constants/images";
import { WALLET, MARKET_PLACE } from "src/constants/routes";
import { useNavigate } from "react-router-dom";
import ChangeNameModal from "components/Modals/ChangeNameModal";
import { ClOSE, CLASS_TYPE_ICON } from "src/constants/images";
import NameModal from "components/Modals/NameModal";
import * as icon from "services/icon";
import { SYMBOL_VALIDATION } from "src/constants/regex";
import { WALLET_TYPE } from "src/constants/walletType";
import ConnectWalletModal from "components/Modals/ConnectWalletModal";
import { BsBoxArrowUpRight } from "react-icons/bs";
export default function GangstaInfo(props) {
  const {
    data,
    address,
    changeNameLoading,
    setChangeNameLoading,
    changeNameSuccess,
    setChangeNameSuccess,
    connectLoading,
    setConnectLoading,
    connectSuccess,
    setConnectSuccess,
    onSuccess,
    nftData,
    currentName,
    walletType,
    walletPath,
    transport,
    getTxResultWithTimer,
    gbetInWallet,
    accumulatedGbet,
    storiesList,
    featuredStoryContent,
    nftId,
  } = props;
  const navigate = useNavigate();
  // console.log(featuredStoryContent);
  const handleRedirectionMarketPlace = () => {
    navigate(`${MARKET_PLACE.INDEX}?class_type=${props.class_type}`);
    window.location.reload();
  };
  const handleRedirection = (address) => {
    navigate(WALLET.addSlug(WALLET.INDEX, address));
  };

  // ------------------------
  const [newName, setNewName] = useState("");
  const [alert, setAlert] = useState(false);
  const [nameChangeCost, setNameChangeCost] = useState(0);
  const [name, setName] = useState(false);
  const [nameValidation, setNameValidation] = useState("");
  const [isChangenameVisible, setChangeName] = useState(false);
  const [nameLoading, setNameLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const checkName = async () => {
    setNameLoading(true);
    const res = await icon.verifyUniqueName(newName);

    if (res === 1) {
      setAlertMessage(
        `${newName} already exist. Please try again with another name.`
      );
      setAlert(true);

      setTimeout(() => {
        setAlert("");
      }, 4000);
    } else {
      changeName();
    }
  };

  const changeName = async () => {
    handleNameModalClose();
    if (address && newName.length > 2) {
      setChangeNameSuccess({ status: "loading" });
      setChangeName(false);
      setChangeNameLoading(true);
      const res = await icon.changeName(
        address,
        newName,
        data.token_id.toString(16),
        walletType,
        walletPath,
        transport
      );

      if (WALLET_TYPE.LEDGER == walletType) {
        if (res?.name == "TransportStatusError") {
          setChangeNameSuccess({ status: "cancel" });
        } else if (res) {
          getTxResultWithTimer(res);
        } else {
          setChangeNameSuccess({ status: "error" });
        }
      }
    } else if (!address) {
      setConnectSuccess({ status: "loading" });
      setConnectLoading(true);
      handleLogin();
    } else if (isChangenameVisible && newName.length === 0) {
      setAlertMessage("Please fill-up name field before moving further.");
      setAlert(true);
    } else {
      setChangeName(true);
    }
  };

  const handleLogin = async () => {
    icon.handleLogin();
  };

  useEffect(() => {
    getNftNameChangeCost();
  }, []);

  const getNftNameChangeCost = async () => {
    const cost = await icon.getNftNameChangeCost();
    setNameChangeCost(cost);
  };

  const handleInputChange = async (e) => {
    await setNewName(e.target.value);
  };

  const handleValidation = () => {
    if (newName == "") {
      setNameValidation("Name field should be above 2 characters.");
    } else if (!SYMBOL_VALIDATION.test(newName)) {
      setNameValidation("");
    } else {
      setNameValidation("Name cannot contain symbols.");
    }
  };

  const handleClose = () => {
    setChangeNameLoading(false);
    setNameValidation("");
    setChangeNameSuccess({ status: "loading" });
    setNewName("");
    if (changeNameSuccess.status === "success") {
      onSuccess();
    }
  };

  const handleWalletClose = () => {
    setConnectLoading(false);
    setConnectSuccess({ status: "loading" });
  };

  const handleNameModalClose = () => {
    setName(false);
    setNameValidation("");
  };

  // -------------------------------
  return (
    <div className="gp-gangsta-info-container">
      <div className="gp-info">
        <div className="owned-by d-flex">
          <div className="text" style={{ marginRight: "3px" }}>
            Owned By:{" "}
          </div>
          <div
            className="hex"
            onClick={() => handleRedirection(props.owned_by)}
          >
            {props.owned_by}
            {/* ...{props.owned_by.substr(props.owned_by.length - 20)} */}
          </div>
        </div>
        <div className="nameContainer">
          <h2>{props.token_name}</h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            {address === nftData.owner ? (
              <button className="gp-cta blue" onClick={() => setName(true)}>
                Change name
              </button>
            ) : null}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="subInfo d-flex">
            <div
              className={`gp-badge gangsta-class-type ${props?.class_type?.toLowerCase()}`}
              onClick={() => handleRedirectionMarketPlace()}
              style={{ marginRight: "10px" }}
            >
              {props.class_type}
            </div>
            <img
              src={
                nftData.isGangster == "0x1"
                  ? CLASS_TYPE_ICON.GANGSTER
                  : CLASS_TYPE_ICON.DETECTIVE
              }
            />

            <div style={{ marginLeft: "5px", color: "var(--profile-amount)" }}>
              {nftData.isGangster == "0x1" ? `Gangster` : `Detective`}
            </div>
          </div>
          <div
            onClick={() => {
              window.open(
                `https://craft.network/nft/gangstabet:${Number(nftId)}`,
                "_blank"
              );
            }}
            className="viewInCraft"
          >
            <p>View in Craft</p> <BsBoxArrowUpRight className="arrow" />
          </div>
        </div>
      </div>

      <ChangeNameModal
        isVisible={changeNameLoading}
        success={changeNameSuccess}
        onClick={handleClose}
        name={newName}
        gbetInWallet={gbetInWallet}
        nameChangeCost={nameChangeCost}
      />
      {alert && (
        <div
          class="alert alert-warning alert-dismissible fade show"
          role="alert"
        >
          {alertMessage}
          <span className="ms-2 mb-1 close" onClick={() => setAlert(false)}>
            <img src={ClOSE.SOURCE} alt="close" className="mb-0" />
          </span>
        </div>
      )}
      <NameModal
        isVisible={name}
        onChangeName={checkName}
        nameloader={nameLoading}
        nameChangeCost={nameChangeCost}
        gbetInWallet={gbetInWallet}
        onChange={handleInputChange}
        accumulatedGbet={accumulatedGbet}
        name={newName}
        onClose={handleNameModalClose}
        onBlur={handleValidation}
        nameValidation={nameValidation}
        currentName={currentName}
      />
      <ConnectWalletModal
        isVisible={connectLoading}
        response={connectSuccess}
        onClick={handleWalletClose}
      />
    </div>
  );
}
